import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'
import { throttle } from 'lodash'

import createRootReducers from '../reducers/rootReducers'
import rootSaga from '../sagas/rootSaga'
import { loadState, saveState } from './localStorage'

export const history = createBrowserHistory()
const sagaMiddleware = createSagaMiddleware()
const persistedState = loadState()
const reducers = createRootReducers(history)

const store = createStore(
  reducers,
  persistedState,
  composeWithDevTools(
    applyMiddleware(
      sagaMiddleware,
      routerMiddleware(history)
    )
  )
);

store.subscribe(throttle(() => {
  saveState({
    router: store.getState().router,
    authentication: store.getState().authentication,
    dashboard: store.getState().dashboard,
    error: store.getState().error,
    password: store.getState().password,
    progress: store.getState().progress,
    role: store.getState().role,
    user: store.getState().user,
    userCreate: store.getState().userCreate,
    userDetail: store.getState().userDetail,
    userEdit: store.getState().userEdit,
    bank: store.getState().bank,
    bankCreate: store.getState().bankCreate,
    bankDetail: store.getState().bankDetail,
    bankEdit: store.getState().bankEdit,
    corporate: store.getState().corporate,
    corporateCreate: store.getState().corporateCreate,
    corporateDetail: store.getState().corporateDetail,
    corporateEdit: store.getState().corporateEdit,
    campaign: store.getState().campaign,
    campaignCreate: store.getState().campaignCreate,
    campaignDetail: store.getState().campaignDetail,
    campaignEdit: store.getState().campaignEdit,
    file: store.getState().file,
    //upload: store.getState().upload,
    plick: store.getState().plick,
    profile: store.getState().profile,
    contoCorrente: store.getState().contoCorrente,
    contoCorrenteCreate: store.getState().contoCorrenteCreate,
    contoCorrenteEdit: store.getState().contoCorrenteEdit,
    report: store.getState().report,
    fileHistory: store.getState().fileHistory,
    authNavbar: store.getState().authNavbar
  })
}), 1000)

sagaMiddleware.run(rootSaga);

export default store;